<template>
  <v-row align="left" no-gutters>
    <v-col cols="auto">
      <div class="text-medium-emphasis">{{ titulo }}</div><br>
    </v-col>
  </v-row>

  <v-row justify="center" align="left" no-gutters>
    <v-col cols="auto" class="sketch-eq">=</v-col>

    <v-col cols="4">
      <v-text-field
      :disabled="disabled"
        v-model.number="localVariable"
        density="compact"
        rounded="sm"
        variant="outlined"
        type="number"
        :rules="[rules.required]"
        @blur="checkEmpty('variable')"
      />
      <div class="text-subtitle-2 text-center mt-1">  {{ $t('simulacion.modulo.curvas_CAPEXOPEX.variable') }}<span v-if="unidadVariable">({{ unidadVariable }})</span>


      </div>
    </v-col>

    <v-col cols="auto" class="sketch-eq">×</v-col>
    <v-col cols="auto" class="sketch-eq">+</v-col>

    <v-col cols="4">
      <v-text-field
      :disabled="disabled"
        v-model.number="localFijo"
        density="compact"
        rounded="sm"
        variant="outlined"
        type="number"
        :rules="[rules.required]"
        @blur="checkEmpty('fijo')"
      />
      <div class="text-subtitle-2 text-center mt-1">{{ $t('simulacion.modulo.curvas_CAPEXOPEX.fijo') }}<span v-if="unidadFijo">({{ unidadFijo }})</span>

      </div>
    </v-col>
  </v-row>
</template>

<script>
import Swal from "sweetalert2";
export default {
  props: {
  disabled:{
      type:Boolean,
      default:false
    },
    titulo: {
      type: String,
      required: true
    },
    valorVariable: {
      type: Number,
      required: true
    },
    valorFijo: {
      type: Number,
      required: true
    },
    unidadVariable: {
    type: String,
    default: '' // por si no se pasa
  },
  unidadFijo: {
    type: String,
    default: ''
  }
  },
  emits: ['update:valorVariable', 'update:valorFijo'],
  data() {
    return {
      localVariable: this.valorVariable,
      localFijo: this.valorFijo,
      rules: {
         required: v => (v !== null && v !== undefined && v !== '' ) || v === 0 || this.$t('mensajes.campo_requerido'),
      }
        
    };
  },
  watch: {
    localVariable(val) {
      this.$emit('update:valorVariable', val);
    },
    localFijo(val) {
      this.$emit('update:valorFijo', val);
    },
    valorVariable(val) {
      this.localVariable = val;
    },
    valorFijo(val) {
      this.localFijo = val;
    }
  },
  methods: {
  checkEmpty(field) {
    const value = field === 'variable' ? this.localVariable : this.localFijo;

    if (value === null || value === '' || value === undefined) {
      Swal.fire({
        icon: 'warning',
        title: this.$t('mensajes.campo_requerido'),
        text: this.$t('mensajes.campo_requerido_opexcapex'),
        confirmButtonText: 'OK',
      });
    }
  }
}

};
</script>

<style scoped>
.sketch-eq {
  font-size: 24px;
  margin: 0 8px;
}
</style>
